import { registerAction } from "@builder.io/sdk-react";

export default function registerActions() {
  registerAction({
    name: "Open Modal",
    kind: "function",
    id: "open-modal-action",
    inputs: [
      {
        name: "modalId",
        type: "string",
        defaultValue: "modal-default",
        required: true,
        helperText: "Modal Id set in the modal block",
      },
    ],
    action: (options) => `state["${options.modalId}"] = true;`,
  });
  registerAction({
    name: "Open Lightbox",
    kind: "function",
    id: "open-lightbox-action",
    inputs: [
      {
        name: "lightboxId",
        type: "string",
        defaultValue: "lightbox-default",
        required: true,
        helperText: "Lightbox Id set in the lightbox block",
      },
      {
        name: "initialImage",
        type: "number",
        defaultValue: 1,
        required: true,
        helperText: "If multiple images, select which one will be opened.",
      },
    ],
    action: (options) =>
      `state["${options.lightboxId}"] = { open: true, initialImage: ${options.initialImage} };`,
  });
}
